import { LOCALES } from '@marketplace/i18n';

export const landingPageHeader = {
  [LOCALES.ENG]: {
    developer_landing_header_sub_logo: 'Developer Platform',
    developer_landing_header_navigation_sign_in: 'Login',
    developer_landing_header_navigation_developer_platform:
      'DASHBOARD',
    developer_landing_header_navigation_api_documentation: 'API DOCUMENTATION',
    developer_landing_header_navigation_design_system: 'DESIGN SYSTEM',
    developer_landing_header_navigation_application_gallery:
      'APP GALLERY',
    developer_landing_header_navigation_my_account: 'My Account',
    developer_landing_header_Edit_User_And_Purpose_Info:"Please note: Intended User(s) and Intended Purpose(s) fields must be defined for all apps. Add them on the Edit App screen."
  },
};
